import React, { Fragment } from "react";
const recognition = [
  {
    image:
      `${process.env.REACT_APP_CDN_URL}/assets/images/public-home/awards/fcci.svg`,
    title: "MSME Ecosystem Awards",
  },
  {
    image:
      `${process.env.REACT_APP_CDN_URL}/assets/images/public-home/awards/nasscom.svg`,
    title: "AI Gamechangers Winner",
  },
  {
    image:
      `${process.env.REACT_APP_CDN_URL}/assets/images/public-home/awards/fintech_india.svg`,
    title: "Best use of AI in FinTech",
  },
  {
    image:
      `${process.env.REACT_APP_CDN_URL}/assets/images/public-home/awards/aegis.svg`,
    title: "Finalists at AGBA Awards",
  }
];
const Recognized = () => {

  return (
    <Fragment>
      <div className='d-flex flex-column justify-content-center align-items-center'>
        <div className='align-self-center d-flex flex-column justify-content-center'>
          <h2 className="businessTitle text-center ff-renner-bold">
            Recognized as a leader
          </h2>
          <div className='align-self-center d-flex justify-content-center mb-5'>
            <div className='line text-primary bg-primary mt-4' />
          </div>
        </div>
      </div>
      <div className="row mt-4 justify-content-center">

        {recognition.map((each, index) => {
          return (
            <>
              <div className="col-lg-3 col-md-4 col-12 mt-4 p-3" key={index}>
                <div className="d-flex align-items-center justify-content-center flex-column h-100">
                  <img
                    className="mb-2"
                    src={each.image}
                    alt="Card image cap"
                  />
                  <h4 className="text-center direct-chat-name ff-renner-book w-75 align-self-center a">{each.title}</h4>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </Fragment>
  );

}
export default Recognized;
